<div (scroll)="onScroll($event)" class="parent" *ngIf="data?.length">
  <div [ngClass]="{'grid': !showQtr, 'grid-4': showQtr}">
    <span class="columnHeader" *ngFor="let t of columns">
      {{ t }}
    </span>
  </div>
  <div class="gridRow" [ngClass]="{'grid': !showQtr, 'grid-4': showQtr}" *ngFor="let k of data">
    <span style="display: contents;" *ngIf="k.month || k.day || k.year || k.quarter">
      <span *ngIf="k.month !== null && k.month !== undefined && k.month !== 0; else unknownDateData">{{ k.longMonthString }} </span>
      <span><span *ngIf="k.day !== 0; else unknownDateData"> {{ k.day }} </span></span>
      <span class="pertinent"><span *ngIf="k.year !== 0; else unknownDateData">{{ k.year }}</span></span>
      <span *ngIf="showQtr"><span *ngIf="k.quarter !== 0; else unknownDateData">{{ ordinalSuffix(k.quarter) }}</span></span>
    </span>
  </div>
</div>

<div class="recordCount" *ngIf="data?.length; else noData">
  {{ data.length }} date record(s)
</div>
<ng-template #unknownDateData>
  <span title="Unknown">--</span>
</ng-template>
<ng-template #noData>
  <div class="recordCount">We don't have any Dates for this record.</div>
</ng-template>
